import type { Step } from "react-joyride";

export const meetingActionsTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ສະແດງລາຍການປະເດັນທີ່ລົມກັນຈາກບັນທຶກການປະຊຸມ. ທ່ານສາມາດກັ່ນຕອງຕາມວັນສົ່ງ, ສະຖານະ, ຜູ້ຮັບຜິດຊອບ ແລະ ມາກສຳເລັດ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="meeting-actions-header"]',
    content:
      "ຫົວຂໍ້ຕິດຕາມປະເດັນທີ່ລົມກັນ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="meeting-actions-filter"]',
    content:
      "ເລືອກວັນສົ່ງ, ສະຖານະ (ລໍຖ້າ/ສຳເລັດ), ຜູ້ຮັບຜິດຊອບ ເພື່ອກັ່ນຕອງປະເດັນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="meeting-actions-table"]',
    content:
      "ຕາຕະລາງປະເດັນ. ກົດລາຍລະອຽດເພື່ອເບິ່ງ popup, ກົດຫົວຂໍ້ປະຊຸມເພື່ອໄປບັນທຶກການປະຊຸມ, ຫຼື ມາກສຳເລັດ.",
    placement: "top",
  },
];
